import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {interventionsFeatureKey, InterventionsState} from "./interventions.reducer";

export const getInterventionsState = createFeatureSelector<InterventionsState>(interventionsFeatureKey);

export const getInterventions = createSelector(getInterventionsState, (state) => state.data);
export const getInterventionsLoading = createSelector(getInterventionsState, SelectorUtil.isLoading);
